import React, { useState } from "react";

// Utils //
import useElementSize from "../../../hooks/useElementSize";

// Components //
import Breadcrumb, {
    CustomBreadcrumb,
} from "../../atoms/breadcrumb/breadcrumb";
import EnterpriseMentorshipValidatorForm from "../enterprise-mentorship-validator-form/EnterpriseMentorshipValidatorForm";
import FormEnterpriseMentorship from "../form-enterprise-mentorship/FormEnterpriseMentorship";
import StepsToFindTalent from "../steps-to-find-talent/StepsToFindTalent";
import Button from "../../atoms/button/button";
import IconTime from "../../../assets/images/icons/icon-reloj.svg";

// Interfaces //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles //
import "./EnterpriseMentorshipValidator.scss";
import BannerImgTxtBtn from "../../molecules/banner-img-txt-btn/Banner-img-txt-btn";

const MAIN_CLASS = "o-enterprise-mentorship-validator";

const breadcrumbItems: CustomBreadcrumb[] = [
    {
        title: "Empresas",
        url: "/servicio-de-empleo/empresas",
    },
    {
        title: "Mentoría empresarial",
        url: "/servicio-de-empleo/empresas/mentoria-empresarial",
    },
    {
        title: "Verificador",
    },
];

enum Steps {
    VALIDATOR = "VALIDATOR",
    RESULTS = "RESULTS",
    RESULTLESS = "RESULTLESS",
}
const EnterpriseMentorshipValidator = (props: ReferenciaContenido) => {
    const headerSize = useElementSize(".m-header");
    const [step, setStep] = useState(Steps.VALIDATOR);
    const dataformStepValidatos = props?.referenciaFormularios?.[0] || {};
    const sectionGenerals = props?.categoriasGenerales || [];
    const [mentoringValidator, setMentoringValidator] = useState<any>(null);


    const getBannerProps = () => {
        if (step === Steps.RESULTS) {
            return {
                imagenLogo: sectionGenerals[0]?.imagenPrincipal?.file?.url || "",
                tituloBanner: `La empresa ${mentoringValidator?.razon_social} registrada con NIT ${mentoringValidator?.nit}`,
                descripcionBanner: "Ya recibió una Mentoría Empresarial. Recuerda que con este NIT puedes acceder a una Mentoría Empresarial sin costo al año.",
                tituloBotonBanner: "Conoce las Mentorías Especializadas",
                href: "https://tiendaempresas.comfama.com/crecimiento-empresarial/empleo"
            };
        }
        if (step === Steps.RESULTLESS) {
            return {
                imagenLogo: sectionGenerals[1]?.imagenPrincipal?.file?.url || "",
                tituloBanner: "¡Preparate para tu primera mentoría empresarial! ",
                descripcionBanner: "Tu empresa aun no ha recibido una mentoría empresarial sin costo, elige la más acorde a tus necesidades y solicitala ahora.",
                tituloBotonBanner: "Solicita una mentoría empresarial",
                href: "../../solicitud-servicios/"
            };
        }
        return {};
    };

    // Esta función será llamada desde el form
    const handleMentoringValidator = (data: any) => {
        if (data.data === null) {
            setMentoringValidator(data);
            setStep(Steps.RESULTLESS);
            return;
        }
        setMentoringValidator(data.data);
        setStep(Steps.RESULTS);
    };

    return (
        <div
            className={MAIN_CLASS}
            style={{ marginTop: `${headerSize.height}px` }}
        >
            <div className={`container`}>
                <div className={`${MAIN_CLASS}__breadcrumbs`}>
                    <Breadcrumb
                        content={""}
                        useCustomBreadcrumbs
                        customBreadcrumbs={breadcrumbItems}
                    />
                </div>

                <div className={`${MAIN_CLASS}__content`}>
                    {step === Steps.VALIDATOR && (
                        <EnterpriseMentorshipValidatorForm
                            referenciaFormulario={dataformStepValidatos}
                            onMentoringValidator={handleMentoringValidator}
                        />
                    )}
                    {step === Steps.RESULTS && mentoringValidator && (
                        <div className={`${MAIN_CLASS}__results`}>
                            <div className={`${MAIN_CLASS}__results__title`}>
                                <h1>Verificador de mentorías empresariales</h1>
                            </div>
                            <BannerImgTxtBtn {...getBannerProps()}/>
                            <FormEnterpriseMentorship
                                initialCompanyName={mentoringValidator?.razon_social}
                                initialDocumentNumber={mentoringValidator?.nit}
                            />
                        </div>
                    )}
                    {step === Steps.RESULTLESS && mentoringValidator && (
                        <div className={`${MAIN_CLASS}__results`}>
                            <div className={`${MAIN_CLASS}__results__title`}>
                                <h1>Verificador de mentorías empresariales</h1>
                            </div>
                            <BannerImgTxtBtn {...getBannerProps()}/>
                            <StepsToFindTalent
                                {...sectionGenerals[1]}
                            />
                            <div className={`${MAIN_CLASS}__results__adviser`}>
                                <img
                                    src={IconTime}
                                />
                                <h2>Todas las Mentorias Empresariales tienen una duración de 2 horas y pueden ejecutarse en modalidad virtual y presencial.</h2>
                            </div>
                            <div className={`${MAIN_CLASS}__results__button`}>
                                <Button
                                    type="link"
                                    text="Conoce más sobre Mentorías Empresariales"
                                    classname="banner-img-text-btn__button"
                                    isDisabled={false}
                                    href={"../"}
                                /> 
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EnterpriseMentorshipValidator;
